module.exports = __webpack_public_path__ + "img/investments.bbbe824e.svg";